import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/features/auth/store/authStore';

interface Props {
  /** Permission atom required to access child routes (e.g. 'tickets:read'). */
  permission?: string;
}

/**
 * Wraps a group of routes with authentication + optional permission check.
 *
 * Usage:
 *   <Route element={<ProtectedRoute />}>               // auth only
 *   <Route element={<ProtectedRoute permission="tickets:read" />}>  // auth + permission
 */
export function ProtectedRoute({ permission }: Props) {
  const { isAuthenticated, user } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (permission && !user?.permissions.includes(permission)) {
    return <Navigate to="/departments" replace />;
  }

  return <Outlet />;
}
